type ToggleSize = 'small' | 'medium' | 'large'

interface ToggleProps {
  checked: boolean
  onChange: (value: boolean) => void
  size?: ToggleSize
  readOnly?: boolean
  ariaLabel?: string
}

const sizeConfig = {
  small: {
    container: 'h-5 w-9',
    knob: 'h-4 w-4 top-0.5',
    translate: { on: 'translate-x-[18px]', off: 'translate-x-0.5' },
  },
  medium: {
    container: 'h-7 w-13',
    knob: 'h-6 w-6',
    translate: { on: 'translate-x-[26px]', off: 'translate-x-0.5' },
  },
  large: {
    container: 'h-9 w-16',
    knob: 'h-8 w-8',
    translate: { on: 'translate-x-[30px]', off: 'translate-x-0.5' },
  },
}

export const Toggle = ({
  checked,
  onChange,
  size = 'small',
  readOnly = false,
  ariaLabel,
}: ToggleProps) => {
  const config = sizeConfig[size]

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={readOnly}
      onClick={(e) => {
        e.stopPropagation()
        if (!readOnly) {
          onChange(!checked)
        }
      }}
      className={`relative inline-flex ${config.container} flex-shrink-0 rounded-full border-none transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2
                ${readOnly ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'}
                ${checked ? 'bg-gradient-orange-fuschia focus:ring-orange' : 'bg-gray-300 focus:ring-gray-300'}`}
    >
      {/* className={`border-none
                ${enabled ? 'bg-gradient-orange-fuschia' : 'bg-gray-300'}`} */}
      <span
        className={`absolute inline-block ${config.knob} top-0.5 transform rounded-full bg-white shadow-1 transition-transform duration-200
                  ${checked ? config.translate.on : config.translate.off}`}
      />
      {/* <span
        className={`absolute
                  ${enabled ? 'translate-x-[18px]' : 'translate-x-[2px]'}`}
      /> */}
    </button>
  )
}
